import { useEffect, useState } from "react"
import { useDependency } from "../../../../contexts/DependencyProvider"
import { ListFPARequest2 } from "../../../../services/soap/project/requests/ListFPARequest2";
import styles from "./contact_detail_view.module.css"
import { Flex, Link, View } from "@adobe/react-spectrum";
import ChevronRight from "@spectrum-icons/workflow/ChevronRight";
import { invokeFinderApp } from "../../../../utils/NavigationUtils";
const RelatedContexts = ({contact}:any)=>{
    const {store,projectService} = useDependency();

    const [relatedContext,setRelatedContext] = useState({
        activities: {},
        projects: {},
        folders: {},
      });

    type GroupedItem = {
        parent: any;
        icon: JSX.Element;
        name: any;
        id:any,
        folder?:any,
        project?:any,
        activity?:any
      };
      type GroupedData = {
        activities: Record<string, GroupedItem[]>;
        projects: Record<string, GroupedItem[]>;
        folders: Record<string, GroupedItem[]>;
      };

      const groupItemsByType = (data: any[]): GroupedData => {
        const grouped: GroupedData = { activities: {}, projects: {}, folders: {} };
      
        data.forEach((entry:any) => {
          const item = entry.ITEM;
          const icon = <ChevronRight size="S" UNSAFE_style={{ color: "#909090" }} />;
      
          if (item.ACTIVITY) {
            const { activityTypeName, contextParentName, name,id,folder,project } = item.ACTIVITY;
            if (!grouped.activities[activityTypeName]) {
              grouped.activities[activityTypeName] = [];
            }
            grouped.activities[activityTypeName].push({
              parent: contextParentName,
              icon,
              name,
              id,
              activity:id,
              folder,
              project
            });
          }
      
          if (item.PROJECT) {
            const { projectTypeName, contextParentName, name,id,folder } = item.PROJECT;
            if (!grouped.projects[projectTypeName]) {
              grouped.projects[projectTypeName] = [];
            }
            grouped.projects[projectTypeName].push({
              parent: contextParentName,
              icon,
              name,
              id,
              project:id,
              folder,
            });
          }
      
          if (item.FOLDER) {
            const { folderTypeName, contextParentName, name,id } = item.FOLDER;
            if (!grouped.folders[folderTypeName]) {
              grouped.folders[folderTypeName] = [];
            }
            grouped.folders[folderTypeName].push({
              parent: contextParentName,
              icon,
              name,
              id,
            });
          }
        });
      
        return grouped;
      };

    const getRelatedContexts = async()=>{
        try {
            var response = await projectService.listFPA2(new ListFPARequest2(store.Server, store.SessionId,{
              flatView:true,
              folderFilter:{ COL: [{ name: 'externalContact', type: 'equals',value:contact.id }] },
              projectFilter:{ COL: [{ name: 'externalContact', type: 'equals',value:contact.id }] },
              activityFilter:{ COL: [{ name: 'externalContact', type: 'equals',value:contact.id }] },
            }));
            setRelatedContext(groupItemsByType(response.ITEMS));
          } catch (error) {
            console.log('error', error);
          }
    }

    useEffect(()=>{
        getRelatedContexts();
    },[contact])
    
    const openInvokeApp = (id:any)=>{
        invokeFinderApp(id)
    }

    return(
        <Flex direction={'column'}>
        {relatedContext &&
          Object.entries(relatedContext.folders).map(([type, items]:any)=>(
              <View marginTop={10} UNSAFE_className={styles['address-parent']}>
              <b key={type} className={styles.address}>{type}</b>
              <View UNSAFE_className={styles['value-wrapper']}>
                  <View UNSAFE_className={styles.value}>
                    {items.map((item:any, index:number) => (
                      <p key={index} className={styles.bristol}>
                      <Link onPress={()=>openInvokeApp(item.id)} isQuiet>
                        <span>{item.name}</span>
                      </Link>
                      </p>
                    ))}
                  </View>
              </View>
            </View>
          ))
        }
        {relatedContext &&
          Object.entries(relatedContext.projects).map(([type, items]:any)=>(
              <View marginTop={10} UNSAFE_className={styles['address-parent']}>
              <b key={type} className={styles.address}>{type}</b>
              <View UNSAFE_className={styles['value-wrapper']}>
                  <View UNSAFE_className={styles.value}>
                  {items.map((item:any, index:number) => (
                    <p key={index} className={styles.bristol}>
                      <Link isQuiet onPress={()=>openInvokeApp(item.folder)}>
                        <span>{item.parent}</span>
                      </Link>
                       {item.icon}
                       <Link isQuiet onPress={()=>openInvokeApp(item.id)}><span>{item.name}</span></Link>
                      </p>
              ))}
                    
                  </View>
              </View>
            </View>
          ))
        }
        {relatedContext &&
          Object.entries(relatedContext.activities).map(([type, items]:any)=>(
              <View marginTop={10} UNSAFE_className={styles['address-parent']}>
              <b key={type} className={styles.address}>{type}</b>
              <View UNSAFE_className={styles['value-wrapper']}>
                  <View UNSAFE_className={styles.value}>
                  {items.map((item:any, index:number) => (
                      <p key={index} className={styles.bristol}>
                        <Link isQuiet onPress={()=>openInvokeApp(item.id)}>
                          <span>{item.parent}</span> 
                        </Link>
                        {item.icon} 
                        <Link isQuiet onPress={()=>openInvokeApp(item.id)}>
                          <span>{item.name}</span>
                        </Link>  
                      </p>
              ))}
                    
                  </View>
              </View>
            </View>
          ))
        }
        </Flex>
    )
}
export default RelatedContexts